import { render, staticRenderFns } from "./PhieuThongTinNhanPhong.vue?vue&type=template&id=6a67f124&scoped=true"
import script from "./PhieuThongTinNhanPhong.vue?vue&type=script&lang=js"
export * from "./PhieuThongTinNhanPhong.vue?vue&type=script&lang=js"
import style0 from "./PhieuThongTinNhanPhong.vue?vue&type=style&index=0&id=6a67f124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a67f124",
  null
  
)

export default component.exports